import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function EventPage() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  // const fetchEventData = async () => {
  //   try {
  //     setLoading(true);
  //     fetch("/event.json")
  //       .then((res) => res.json())
  //       .then((data) => {
  //         const matchedEvent = data.find((e) => (e.id = id));
  //         setEvent(matchedEvent);
  //         setLoading(false);
  //       });
  //   } catch (error) {
  //     console.error("Failed to fetch event data: ", error);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetch("/event.json")
      .then((res) => res.json())
      .then((data) => {
        const matchedEvent = data.find((e) => e.id == id);

        setEvent(matchedEvent);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch event data:", err);
        setLoading(false);
      });
  }, [id]);

  // useEffect(() => {
  //   fetchEventData();
  // }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!event) return <h2>Event not found</h2>;

  return (
    <>
      {/* <div
        style={{
          marginTop:'120px',
          backgroundImage: `url(${event.headerImage})`,
          width:"auto",
          height: "500px",
          backgroundSize: "contain",
          backgroundRepeat:'no-repeat',
          backgroundPosition: "center",
          // position: "relative",
        }}
      >
       
      </div> */}
      <div className="container-fluid">
        <img
          style={{
            marginTop:'120px',
            width: "100%",
          }}
          className="text-center"
        
            
          src={event.headerImage}
          alt=""
        />
      </div>

      <div className="container">
        <div className="text-center mx-auto mt-4 py-4 ">
          <h1
            style={{
              minWidth: "300px",
              color: `var(--Mindox-blue)`,
            }}
            className="text-center event-title"
          >
            {event.title}
          </h1>
        </div>
      </div>

      <div className="container py-4">
        <div className="mx-auto text-center">
          <div className="row justify-content-center">
            <div className="col-md-5 my-3">
              <img
                src={event.images[0]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
            <div className="col-md-5 my-3">
              <img
                src={event.images[1]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
          </div>
          <div className="mt-5">
            <div className="row">
              <div className="col-md-10 mx-auto">
                {event.description.map((para, index) => (
                  <p
                    key={index}
                    style={{ textAlign: "justify" }}
                    className="mb-3 fw-light text-justify"
                  >
                    {para}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="row justify-content-center ">
            <div className="col-md-5 my-3">
              <img
                src={event.images[2]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
            <div className="col-md-5  my-3">
              <img
                src={event.images[3]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
          </div>
          <div className="row justify-content-center ">
            <div className="col-md-5 my-3">
              <img
                src={event.images[4]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
            <div className="col-md-5  my-3">
              <img
                src={event.images[5]}
                alt={event.title}
                style={{ minHeight: "400px", width: "auto" }}
                className="img-fluid rounded object-fit-cover mx-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
